import React from "react";
import Header from "../components/Header";
import {link} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../styles/Convu.css";

function Convu() {
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/journey", label: "Our Journey" },
    { to: "/blog", label: "Blogs & Insights" },
    { to: "/get-in-touch", label: "Support" },

    // { to: "/chat", label: "Meet Sparky" }
  ];

  return (
    <>
      <Header links={navLinks} />

      <Helmet>
        <title>Join the Waitlist | Convu by DataPulse AI</title>
        <meta name="description" content="Join the waitlist for Convu - the future of genuine connection, powered by AI. Coming soon from DataPulse AI." />
        <link rel="canonical" href="https://www.mydatapulse.co.uk/convu" />
      </Helmet>

      <div className="page-container">
        <div>
          <img
            src="icons/convu-white-transparent.png"
            alt="Convu Logo"
            className="w-1/2 mx-auto"
          />
        </div>


        <br/>
        <h2 style={{ color: "#00b8db"}} className="subheading text-5xl md:text-xl">The Future of Communication is Here</h2>
        <div className="form-container text-center justify-center">
          <p className="subheading">Join the Convu waitlist!</p>
          <iframe
            src="https://tally.so/embed/mVab46?hideTitle=1&transparentBackground=1&dynamicHeight=1"
            width="100%"
            title="Convu Waiting List"
            style={{ border: 'none' }}
          ></iframe>

        </div>
        <div>
          <p className="description">AI-powered connection. Made human.</p>

          <div className="icon-row">
            <span>🤯</span>
            <span>🔥</span>
            <span>✨</span>
          </div>
        </div>
          <p className="footer-text">Something extraordinary is coming. Are you ready?</p>
      </div>
    </>
  );
}

export default Convu;
